import { useRef, useState } from "react";

export const useUploadProgress = () => {
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef(null);

  const startProgress = () => {
    setProgress(0);
    clearInterval(intervalRef.current);

    // Cập nhật mỗi 50ms (20 khung hình/giây) để tạo độ mượt
    intervalRef.current = setInterval(() => {
      setProgress((prev) => {
        // Nếu đã đến ngưỡng 90% thì dừng lại đợi API
        if (prev >= 90) {
          return 90;
        }

        // Thuật toán "Tiệm cận":
        // Lấy khoảng cách còn lại (90 - prev) nhân với hệ số nhỏ (0.05).
        // Kết quả: Thanh chạy nhanh lúc đầu và tự động chậm dần khi gần đến 90.
        const remaining = 90 - prev;
        const step = remaining * 0.05;

        // Đảm bảo luôn tăng ít nhất 0.1% để không bị đứng im hoàn toàn
        const increment = Math.max(step, 0.1);

        return Math.min(prev + increment, 90);
      });
    }, 50);
  };

  const completeProgress = () => {
    clearInterval(intervalRef.current);
    setProgress(100);
    // Đợi 0.5s để người dùng kịp nhìn thấy thanh đầy 100% trước khi đóng
    return new Promise((resolve) => setTimeout(resolve, 500));
  };

  const resetProgress = () => {
    clearInterval(intervalRef.current);
    setProgress(0);
  };

  return { progress, startProgress, completeProgress, resetProgress };
};
